module.exports = "/_next/static/images/4807d9f81a3adef3f27a6083b7f0f2da-man-with-cellphone-xs@1x.jpg.webp";